import { render, staticRenderFns } from "./AiPromptEdit.vue?vue&type=template&id=72ab2f26&scoped=true"
import script from "./AiPromptEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AiPromptEdit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ab2f26",
  null
  
)

export default component.exports